import { createFilterSlice } from './filterSlice';
import { subDays, format } from 'date-fns';

const STORAGE_KEY = 'auditTableFilters';

export const getDefaultAuditDateRange = () => ({
	fromDate: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
	toDate: format(new Date(), 'yyyy-MM-dd'),
});

const defaultFilters = {
	fromDate: null,
	toDate: null,
	userIds: [],
	actionTypes: [],
	clientId: null,
	clientName: null,
};

export const auditTablePrefsSlice = createFilterSlice({
	sliceName: 'auditTablePrefs',
	storageKey: STORAGE_KEY,
	defaultFilters,
});

export const {
	setFromDate,
	setToDate,
	setUserIds,
	setActionTypes,
	setClientId,
	setClientName,
	resetFilters,
	pruneFilters,
} = auditTablePrefsSlice.actions;

export default auditTablePrefsSlice.reducer;
